(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  let previousFocus, busy = false;
  function open() {
    if (!drawer.classList.contains('is-open')) previousFocus = document.activeElement;
    drawer.inert = false; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('pp-drawer-open'); drawer.querySelector('[data-cart-close][type="button"]')?.focus();
  }
  function close() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); drawer.inert = true;
    document.body.classList.remove('pp-drawer-open'); previousFocus?.focus();
  }
  async function refresh(keepOpen = false) {
    const response = await fetch(root + '?section_id=cart-drawer');
    if (!response.ok) throw new Error('cart');
    const doc = new DOMParser().parseFromString(await response.text(),'text/html');
    const next = doc.querySelector('[data-cart-drawer]');
    if (!next) throw new Error('cart');
    drawer.innerHTML = next.innerHTML;
    const cartResponse = await fetch(root + 'cart.js');
    if (!cartResponse.ok) throw new Error('cart');
    const cart = await cartResponse.json();
    document.querySelectorAll('.pp-cart-count').forEach(el => el.textContent = cart.item_count);
    if (keepOpen) open();
  }
  async function change(line, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true; drawer.setAttribute('aria-busy','true');
    drawer.querySelectorAll('button,input').forEach(el => el.disabled = true);
    try {
      const response = await fetch(root + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity})});
      if (!response.ok) throw new Error('cart');
      await refresh(true);
    } catch { location.href = root + 'cart'; }
    finally { busy = false; drawer.removeAttribute('aria-busy'); drawer.querySelectorAll('button,input').forEach(el => el.disabled = false); }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('.pp-header-action--cart')) {event.preventDefault(); open(); return;}
    if (event.target.closest('[data-cart-close]')) {close(); return;}
    const button = event.target.closest('[data-cart-qty-minus],[data-cart-qty-plus],[data-cart-remove]');
    if (!button) return;
    const line = Number(button.dataset.cartQtyMinus || button.dataset.cartQtyPlus || button.dataset.cartRemove);
    const quantity = Number(drawer.querySelector(`[data-cart-qty-input="${line}"]`)?.value || 0);
    change(line, button.hasAttribute('data-cart-remove') ? 0 : Math.max(0,quantity + (button.hasAttribute('data-cart-qty-plus') ? 1 : -1)));
  });
  drawer.addEventListener('change', event => {if (event.target.matches('[data-cart-qty-input]')) change(Number(event.target.dataset.cartQtyInput),Number(event.target.value));});
  document.addEventListener('keydown', event => {
    if (!drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    if (event.key === 'Tab') {
      const nodes = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length-1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
    }
  });
  document.addEventListener('pp:cart-added', () => refresh(true).catch(() => location.href = root + 'cart'));
  window.PinkPalloCartDrawer = {open,refresh};
})();
